<template>
  <div v-if="open" class="overlay" @click.self="$emit('close')">
    <aside class="drawer" role="dialog" aria-label="Справочники">
      <div class="drawer-head">
        <div>
          <h2>Справочники</h2>
          <p>Источники, площадки и метки, из которых собираются ссылки. Правки сразу видны в конструкторе.</p>
        </div>
        <button type="button" class="x" aria-label="Закрыть" @click="$emit('close')">✕</button>
      </div>
      <div class="tabs">
        <button type="button" :class="{ on: tab === 'origins' }" @click="tab = 'origins'">Источники <span class="n">{{ origins.length }}</span></button>
        <button type="button" :class="{ on: tab === 'campaigns' }" @click="tab = 'campaigns'">Кампании <span class="n">{{ campaigns.length }}</span></button>
        <button type="button" :class="{ on: tab === 'content' }" @click="tab = 'content'">Контент <span class="n">{{ contents.length }}</span></button>
      </div>
      <div class="drawer-body">
        <div class="toolbar">
          <div class="search">
            <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>
            <input v-model="query" :placeholder="searchPlaceholder">
          </div>
          <select v-if="tab === 'origins'" v-model="leadFilter" aria-label="Тип трафика">
            <option value="">Все типы</option>
            <option v-for="item in leadOptions" :key="item" :value="item">{{ item }}</option>
          </select>
          <button type="button" class="btn sm primary" @click="openCreate">＋ Добавить</button>
        </div>

        <div v-if="loading" class="empty">Загрузка…</div>
        <div v-else-if="!currentRows.length" class="empty">Записей пока нет</div>
        <div v-else-if="!filtered.length" class="empty">Ничего не найдено</div>
        <div v-else class="table-wrap">
          <table v-if="tab === 'origins'" class="dtable">
            <thead>
              <tr><th>Тип трафика</th><th>Источник</th><th>Площадка</th><th>Событие</th><th>Метки</th><th></th></tr>
            </thead>
            <tbody>
              <tr v-for="row in filtered" :key="row.id">
                <td><span class="pill" :title="row.lead">{{ shortLead(row.lead) }}</span></td>
                <td>{{ row.origin }}</td>
                <td>{{ row.platform }}</td>
                <td>{{ row.event }}</td>
                <td class="mono">{{ row.utm_source || '—' }} · {{ row.utm_medium || '—' }}</td>
                <td class="acts">
                  <button type="button" title="Изменить" @click="openEdit(row)"><i class="pi pi-pencil"></i></button>
                  <button type="button" class="del" title="Удалить" @click="askDelete(row)"><i class="pi pi-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
          <table v-else-if="tab === 'campaigns'" class="dtable">
            <thead>
              <tr><th>Название</th><th>Метка</th><th>Неполная кампания</th><th></th></tr>
            </thead>
            <tbody>
              <tr v-for="row in filtered" :key="row.id">
                <td>{{ row.name }}</td>
                <td class="mono">{{ row.value }}</td>
                <td>{{ row.is_not_complete ? 'Да' : 'Нет' }}</td>
                <td class="acts">
                  <button type="button" title="Изменить" @click="openEdit(row)"><i class="pi pi-pencil"></i></button>
                  <button type="button" class="del" title="Удалить" @click="askDelete(row)"><i class="pi pi-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
          <table v-else class="dtable">
            <thead>
              <tr><th>Название</th><th>Метка</th><th>Постоянная</th><th>Последнее использование</th><th></th></tr>
            </thead>
            <tbody>
              <tr v-for="row in filtered" :key="row.id">
                <td>{{ row.name }}</td>
                <td class="mono">{{ row.value }}</td>
                <td>{{ row.is_static ? 'Да' : 'Нет' }}</td>
                <td>{{ formatStamp(row.last_used_at) }}</td>
                <td class="acts">
                  <button type="button" title="Изменить" @click="openEdit(row)"><i class="pi pi-pencil"></i></button>
                  <button type="button" class="del" title="Удалить" @click="askDelete(row)"><i class="pi pi-trash"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="drawer-foot">
        <span class="note">Удаление не меняет уже созданные ссылки</span>
        <div class="grow"></div>
        <button type="button" class="btn sm" @click="exportCsv">Экспорт CSV</button>
      </div>
    </aside>
  </div>

  <DialogVue v-model:visible="formOpen" modal :header="formTitle" :style="{ width: 'min(720px, 96vw)' }">
    <div class="dict-form">
      <template v-if="tab === 'origins'">
        <div class="grid3">
          <label class="fld"><span class="lbl">Тип трафика</span><input v-model="form.lead" class="input"></label>
          <label class="fld"><span class="lbl">Источник</span><input v-model="form.origin" class="input"></label>
          <label class="fld"><span class="lbl">Площадка</span><input v-model="form.platform" class="input"></label>
        </div>
        <div class="grid3">
          <label class="fld"><span class="lbl">Событие</span><input v-model="form.event" class="input"></label>
          <label class="fld"><span class="lbl">utm_source</span><input v-model="form.utm_source" class="input"></label>
          <label class="fld"><span class="lbl">utm_medium</span><input v-model="form.utm_medium" class="input"></label>
        </div>
        <div class="grid3">
          <label class="fld"><span class="lbl">utm_campaign</span><input v-model="form.utm_campaign" class="input"></label>
          <label class="fld"><span class="lbl">utm_content</span><input v-model="form.utm_content" class="input"></label>
          <label class="fld"><span class="lbl">utm_term</span><input v-model="form.utm_term" class="input"></label>
        </div>
        <p class="hint2">Значение с точкой — подсказка: <code>.utm_campaign</code> выбирается из справочника кампаний, <code>.edit</code> и другие значения с точкой вводятся вручную.</p>
      </template>
      <template v-else>
        <div class="grid2">
          <label class="fld"><span class="lbl">Название</span><input v-model="form.name" class="input"></label>
          <label class="fld"><span class="lbl">Метка</span><input v-model="form.value" class="input"></label>
        </div>
        <label v-if="tab === 'campaigns'" class="switch"><input v-model="form.is_not_complete" type="checkbox"> Неполная кампания</label>
        <label v-else class="switch"><input v-model="form.is_static" type="checkbox"> Постоянная</label>
      </template>
      <p v-if="formError" class="form-error">{{ formError }}</p>
      <div class="foot">
        <button type="button" class="btn sm" @click="formOpen = false">Отмена</button>
        <button type="button" class="btn sm primary" :disabled="saving" @click="save">{{ saving ? 'Сохранение…' : 'Сохранить' }}</button>
      </div>
    </div>
  </DialogVue>
</template>

<script setup>
import { computed, onBeforeUnmount, reactive, ref, watch } from 'vue'
import { useConfirm } from 'primevue/useconfirm'
import { useToast } from 'primevue/usetoast'
import { utmApi } from '@/services/utmApi'
import { downloadCsv } from './utm-utils'

const props = defineProps({
  open: { type: Boolean, default: false },
  origins: { type: Array, default: () => [] },
  campaigns: { type: Array, default: () => [] },
  contents: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})

const emit = defineEmits(['close', 'changed'])
const confirm = useConfirm()
const toast = useToast()

const tab = ref('origins')
const query = ref('')
const leadFilter = ref('')
const formOpen = ref(false)
const saving = ref(false)
const formError = ref('')
const editingId = ref(null)
const form = reactive(emptyForm())

const leadOptions = computed(() => {
  const seen = []
  props.origins.forEach((row) => {
    const value = String(row.lead ?? '').trim()
    if (value && !seen.includes(value)) seen.push(value)
  })
  return seen
})
const searchPlaceholder = computed(() => (
  tab.value === 'origins' ? 'Поиск по событию, источнику, площадке' : 'Поиск по названию и метке'
))
const formTitle = computed(() => {
  const action = editingId.value ? 'Изменить' : 'Добавить'
  if (tab.value === 'origins') return `${action} источник`
  if (tab.value === 'campaigns') return `${action} кампанию`
  return `${action} контент`
})
const currentRows = computed(() => {
  if (tab.value === 'campaigns') return props.campaigns
  if (tab.value === 'content') return props.contents
  return props.origins
})
const filtered = computed(() => {
  const q = query.value.trim().toLowerCase()
  return currentRows.value.filter((row) => {
    if (tab.value === 'origins' && leadFilter.value && String(row.lead ?? '').trim() !== leadFilter.value) return false
    if (!q) return true
    const haystack = tab.value === 'origins'
      ? [row.lead, row.origin, row.platform, row.event, row.utm_source, row.utm_medium]
      : [row.name, row.value]
    return haystack.some((part) => String(part ?? '').toLowerCase().includes(q))
  })
})

watch(tab, () => {
  query.value = ''
  leadFilter.value = ''
})

function onEsc(event) {
  if (event.key === 'Escape' && !formOpen.value) emit('close')
}
watch(() => props.open, (value) => {
  if (value) window.addEventListener('keydown', onEsc)
  else window.removeEventListener('keydown', onEsc)
})
onBeforeUnmount(() => window.removeEventListener('keydown', onEsc))

function emptyForm() {
  return {
    lead: '', origin: '', platform: '', event: '',
    utm_source: '', utm_medium: '', utm_campaign: '', utm_content: '', utm_term: '',
    name: '', value: '', is_not_complete: false, is_static: false,
  }
}
function resetForm() {
  Object.assign(form, emptyForm())
  formError.value = ''
  editingId.value = null
}
function openCreate() {
  resetForm()
  formOpen.value = true
}
function openEdit(row) {
  resetForm()
  editingId.value = row.id
  Object.assign(form, {
    lead: row.lead || '',
    origin: row.origin || '',
    platform: row.platform || '',
    event: row.event || '',
    utm_source: row.utm_source || '',
    utm_medium: row.utm_medium || '',
    utm_campaign: row.utm_campaign || '',
    utm_content: row.utm_content || '',
    utm_term: row.utm_term || '',
    name: row.name || '',
    value: row.value || '',
    is_not_complete: Boolean(row.is_not_complete),
    is_static: Boolean(row.is_static),
  })
  formOpen.value = true
}
function errorText(error, fallback) {
  const message = error?.response?.data?.error
  return typeof message === 'string' ? message : fallback
}
async function save() {
  formError.value = ''
  saving.value = true
  try {
    if (tab.value === 'origins') {
      const body = {
        lead: form.lead, origin: form.origin, platform: form.platform, event: form.event,
        utm_source: form.utm_source, utm_medium: form.utm_medium, utm_campaign: form.utm_campaign,
        utm_content: form.utm_content, utm_term: form.utm_term,
      }
      if (editingId.value) await utmApi.updateOrigin(editingId.value, body)
      else await utmApi.createOrigin(body)
    } else if (tab.value === 'campaigns') {
      const body = { name: form.name, value: form.value, is_not_complete: form.is_not_complete }
      if (editingId.value) await utmApi.updateCampaign(editingId.value, body)
      else await utmApi.createCampaign(body)
    } else {
      const body = { name: form.name, value: form.value, is_static: form.is_static }
      if (editingId.value) await utmApi.updateContent(editingId.value, body)
      else await utmApi.createContent(body)
    }
    formOpen.value = false
    toast.add({ severity: 'success', summary: 'Сохранено', life: 2000 })
    emit('changed')
  } catch (error) {
    formError.value = errorText(error, 'Не удалось сохранить')
    toast.add({ severity: 'error', summary: formError.value, life: 3500 })
  } finally {
    saving.value = false
  }
}
function askDelete(row) {
  const name = tab.value === 'origins' ? (row.event || row.origin) : row.name
  const message = tab.value === 'origins'
    ? `Удалить источник „${name}“? Событие исчезнет из конструктора, уже созданные ссылки не изменятся.`
    : `Удалить «${name}»? Уже созданные ссылки не изменятся.`
  confirm.require({
    message,
    header: 'Удаление',
    icon: 'pi pi-exclamation-triangle',
    acceptLabel: 'Удалить',
    rejectLabel: 'Отмена',
    acceptClass: 'p-button-danger',
    accept: () => remove(row),
  })
}
async function remove(row) {
  try {
    if (tab.value === 'origins') await utmApi.deleteOrigin(row.id)
    else if (tab.value === 'campaigns') await utmApi.deleteCampaign(row.id)
    else await utmApi.deleteContent(row.id)
    toast.add({ severity: 'success', summary: 'Удалено', life: 2000 })
    emit('changed')
  } catch (error) {
    toast.add({ severity: 'error', summary: errorText(error, 'Не удалось удалить'), life: 3500 })
  }
}
function formatStamp(value) {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  return `${dd}.${mm}.${date.getFullYear()}`
}
function shortLead(value) {
  const text = String(value ?? '').trim()
  if (!text) return '—'
  return text.replace(/\s*трафик\s*$/i, '')
}
function exportCsv() {
  if (tab.value === 'origins') {
    downloadCsv('utm-origins.csv', ['lead', 'origin', 'platform', 'event', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'], filtered.value.map((row) => [
      row.lead, row.origin, row.platform, row.event, row.utm_source, row.utm_medium, row.utm_campaign, row.utm_content, row.utm_term,
    ]))
    return
  }
  if (tab.value === 'campaigns') {
    downloadCsv('utm-campaigns.csv', ['name', 'value', 'is_not_complete'], filtered.value.map((row) => [row.name, row.value, row.is_not_complete ? 'true' : 'false']))
    return
  }
  downloadCsv('utm-content.csv', ['name', 'value', 'is_static', 'last_used_at'], filtered.value.map((row) => [
    row.name, row.value, row.is_static ? 'true' : 'false', row.last_used_at || '',
  ]))
}
</script>

<style scoped>
.overlay {
  position: fixed; inset: 0; background: rgba(16, 20, 16, .34); z-index: 40;
  backdrop-filter: blur(1.5px);
}
.drawer {
  --border: #e6e8ec;
  --border-strong: #d5d9e0;
  --text: #14181f;
  --muted: #6b7383;
  --muted-2: #98a0ae;
  --accent: #676B52;
  --accent-hover: #565a44;
  --danger: #b4324f;
  --mono: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  position: fixed; top: 0; right: 0; bottom: 0; width: min(760px, 100%); background: #fff;
  box-shadow: -24px 0 64px -24px rgba(16, 24, 40, .35); display: flex; flex-direction: column; color: var(--text);
}
.drawer-head { display: flex; align-items: flex-start; gap: 12px; padding: 22px 26px 16px; border-bottom: 1px solid var(--border); }
.drawer-head h2 { margin: 0 0 4px; font-size: 18px; font-weight: 600; }
.drawer-head p { margin: 0; font-size: 12.5px; color: var(--muted); }
.x { margin-left: auto; border: 0; background: transparent; color: var(--muted-2); font-size: 18px; padding: 4px 8px; border-radius: 8px; cursor: pointer; }
.x:hover { background: #f3f4f7; color: var(--text); }
.tabs { display: flex; gap: 4px; padding: 12px 26px 0; border-bottom: 1px solid var(--border); }
.tabs button {
  border: 0; background: transparent; padding: 9px 12px 11px; font-size: 13px; font-weight: 500; color: var(--muted);
  border-bottom: 2px solid transparent; margin-bottom: -1px; display: inline-flex; gap: 7px; align-items: center; cursor: pointer; font-family: inherit;
}
.tabs button.on { color: var(--text); border-bottom-color: var(--accent); }
.tabs .n { font-size: 10.5px; background: #f3f4f7; border-radius: 999px; padding: 1px 6px; color: var(--muted); }
.drawer-body { padding: 16px 26px 26px; overflow: auto; flex: 1 1 auto; }
.toolbar { display: flex; gap: 8px; align-items: center; margin-bottom: 14px; }
.toolbar .search {
  flex: 1 1 auto; display: flex; align-items: center; gap: 7px; height: 38px; border: 1px solid var(--border-strong);
  border-radius: 10px; padding: 0 11px; min-width: 0;
}
.toolbar .search input { border: 0; outline: 0; width: 100%; font-size: 13px; background: transparent; color: var(--text); }
.toolbar select {
  height: 38px; border: 1px solid var(--border-strong); border-radius: 10px; padding: 0 28px 0 10px; font-size: 12.5px; background: #fff;
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #98a0ae 50%), linear-gradient(135deg, #98a0ae 50%, transparent 50%);
  background-position: calc(100% - 15px) 50%, calc(100% - 11px) 50%; background-size: 4px 4px; background-repeat: no-repeat;
}
.icon { width: 14px; height: 14px; color: var(--muted-2); flex: 0 0 auto; }
.table-wrap { overflow-x: auto; }
.dtable { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 12.5px; min-width: 640px; }
.dtable th {
  text-align: left; font-size: 10.5px; text-transform: uppercase; letter-spacing: .05em; color: var(--muted-2);
  padding: 0 8px 8px; font-weight: 600; border-bottom: 1px solid var(--border);
}
.dtable td { padding: 10px 8px; border-bottom: 1px solid #f0f2f5; vertical-align: middle; }
.dtable tr:hover td { background: #fbfbfc; }
.mono { font-family: var(--mono); font-size: 11.5px; color: var(--muted); max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pill { font-size: 10.5px; background: #f3f4f7; border-radius: 6px; padding: 2px 6px; color: #4b5361; white-space: nowrap; }
.acts { white-space: nowrap; text-align: right; position: sticky; right: 0; background: #fff; box-shadow: -8px 0 10px -10px rgba(16, 24, 40, .35); }
.dtable tr:hover td.acts { background: #fbfbfc; }
.acts button { border: 0; background: transparent; color: var(--muted-2); padding: 5px; border-radius: 7px; cursor: pointer; }
.acts button:hover { background: #f3f4f7; color: var(--text); }
.acts button.del:hover { color: var(--danger); background: #fdf3f5; }
.empty { text-align: center; color: var(--muted-2); font-size: 12.5px; padding: 32px 0; }
.drawer-foot { display: flex; align-items: center; gap: 10px; padding: 14px 26px; border-top: 1px solid var(--border); background: #fcfcfd; }
.grow { flex: 1 1 auto; }
.note { font-size: 11.5px; color: var(--muted-2); }
.btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 8px; border-radius: 10px;
  border: 1px solid var(--border-strong); background: #fff; padding: 9px 14px; font-size: 13px; font-weight: 500;
  color: var(--text); cursor: pointer; font-family: inherit;
}
.btn:hover { border-color: #b9bfc9; }
.btn.sm { padding: 6px 10px; font-size: 12px; border-radius: 8px; }
.btn.primary { background: var(--accent); border-color: var(--accent); color: #fff; }
.btn.primary:hover { background: var(--accent-hover); border-color: var(--accent-hover); }
.btn:disabled { opacity: .6; cursor: default; }
.dict-form { --muted-2: #98a0ae; --accent: #676B52; --danger: #b4324f; --text: #14181f; }
.dict-form .grid2, .dict-form .grid3 { display: grid; gap: 10px; margin-bottom: 10px; }
.dict-form .grid2 { grid-template-columns: 1fr 1fr; }
.dict-form .grid3 { grid-template-columns: 1fr 1fr 1fr; }
.lbl { display: block; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .05em; color: var(--muted-2); margin: 0 0 6px 2px; }
.dict-form .input {
  height: 38px; border: 1px solid #d5d9e0; border-radius: 10px; padding: 0 12px; width: 100%; font-size: 13px; color: var(--text);
}
.hint2 { font-size: 11px; color: #6b7383; margin: 0 0 12px; }
.hint2 code { font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace; }
.switch { display: flex; align-items: center; gap: 8px; font-size: 13px; margin-bottom: 12px; }
.form-error { color: var(--danger); font-size: 12.5px; margin: 0 0 10px; }
.foot { display: flex; gap: 8px; justify-content: flex-end; }
@media (max-width: 760px) {
  .drawer-head, .drawer-body, .drawer-foot, .tabs { padding-left: 14px; padding-right: 14px; }
  .toolbar { flex-wrap: wrap; }
  .toolbar .search, .toolbar select, .btn, .x, .tabs button, .acts button { min-height: 44px; }
  .toolbar .search input, .toolbar select, .dict-form .input { font-size: 16px; }
  .dict-form .grid2, .dict-form .grid3 { grid-template-columns: 1fr; }
  .dict-form .input { min-height: 44px; }
}
</style>
